import Blue from "~/core";

new Blue({
	name: 'Form Validate',
	selector: "nav.nav",
	setup(nav) {
		const navItems = [...nav.querySelectorAll(".nav__nav-item")];
		const navTriggers = [...nav.querySelectorAll("button.nav__nav-trigger")];

		const openSubNav = item => {
			if (item.matches(".is-open"))	return;
			let openItem = nav.querySelector(".nav__nav-item.is-open");
			if (!!openItem) openItem.classList.remove("is-open");
			let subNav = item.querySelector("ul.nav__sub-nav");
			if (!!subNav) {
				item.classList.add("is-open");
			}
		}

		const closeSubNav = item => {
			if (!item.matches(":focus-within"))	item.classList.remove("is-open");
		}

		navItems.forEach(item => {
			this.$addEvents(item, "mouseover", () => {openSubNav(item)});
			this.$addEvents(item, "mouseleave", () => {closeSubNav(item)});
			this.$addEvents(item, "focusout", () => {closeSubNav(item)})
		});

		navTriggers.forEach(t => {
			this.$addEvents(t, "click.prevent.stop", () => {
				let containerItem = t.closest(".nav__nav-item");
				if (containerItem.matches(".is-open")) closeSubNav(containerItem);
				else openSubNav(containerItem);
			});
		});
	}
});